import { defineAction } from '~/prix'
import inventoryByResidenceReportAction from './publicSafetyInventoryByResidenceReport.action.json' with { type: 'json' }
import { z } from 'zod'
import { reportFormatSchema } from '~/utils/server/report'

const inventoryByResidenceReportDefinition = defineAction({
  ...inventoryByResidenceReportAction,

  input: z.object({
    type: z.enum(['publicSafety']),
    communityId: z.string().nullish(),
    residenceId: z.string().nullish(),
    format: reportFormatSchema,
  }),
  output: z.any(),
})

export default inventoryByResidenceReportDefinition
